import React, { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Input from '../form-components/input/Input';
import Button from '../form-components/input/Button';

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');

  const forgotPassword = async (e: FormEvent) => {
    e.preventDefault();

    const emailRegex = /^\S+@\S+\.\S+$/;

    if (!email) {
      setError('Please enter an email Address');
    } else if (!emailRegex.test(email)) {
      setError('Invalid Email Address');
    } else {
      try {
        setStatus('loading');
        const response = await fetch(
          'https://backend-kyw8.onrender.com/forgot-password',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email }),
          }
        );

        if (!response.ok) {
          if (response.status === 400) {
            toast.error('Invalid email credential', {
              position: 'bottom-right',
            });
            setStatus('fail');
          }
          toast.error('Something went wrong, please try again!!!', {
            position: 'bottom-right',
          });
          setStatus('fail');
        } else {
          await response.json();
          navigate(`/reset-password`, {
            state: {
              email,
            },
          });
          toast.success(`A message has been sent to ${email}`, {
            position: 'bottom-right',
          });
          setStatus('success');
          setEmail('');
          setError('');
        }
      } catch (error) {
        console.log(error);
        setStatus('fail');
      }
    }
  };

  return (
    <div className='main-div'>
      <div className='form-div md:w-full flex flex-col gap-6 border border-[#222222] rounded-[20px]'>
        <h2 className='text-black font-semibold text-3xl text-center'>
          Forgot Password?
        </h2>

        <p className='text-[#222222] text-lg font-normal text-center'>
          Enter your Email Address to reset your password
        </p>

        <form onSubmit={forgotPassword}>
          <div className='mb-2'>
            <Input
              label='Email'
              type='text'
              id='email'
              value={email}
              placeholder='Enter your Email Address'
              onChange={(e) => setEmail(e.target.value)}
              onBlur={() => setError('')}
              errorText={error}
              required
            />
          </div>

          <Button
            type='submit'
            isLoading={status === 'loading'}
            buttonText='Send Recovery Link'
          />
        </form>

        <div>
          <p className='font-semibold text-sm w-full text-center'>
            Remember password?{' '}
            <Link to={'/login'} className='underline'>
              login
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
